module.exports = __webpack_public_path__ + "media/images/edit-e13abdb1c4430ab0001546598406810b.svg";